'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LogInCaptcha = _react2['default'].createClass({
    displayName: 'LogInCaptcha',


    propTypes: {
        'recaptchaPublicKey': _react2['default'].PropTypes.string.isRequired,
        'tabIndex': _react2['default'].PropTypes.number
    },

    componentDidMount: function componentDidMount() {
        // We need to determine if recaptcha has already loaded or if we need to wait for it
        if (window.grecaptcha) {
            this.recaptchaDidLoad();
        } else {
            // Register for an event letting us know that it has been loaded, and then do the thing
            window.addEventListener('hs-recaptcha-did-load', this.recaptchaDidLoad);
        }
    },
    recaptchaDidLoad: function recaptchaDidLoad() {
        if (window.grecaptcha) {
            // Render the captcha
            var container = document.querySelector('.g-recaptcha');
            grecaptcha.render(container, {
                'sitekey': this.props.recaptchaPublicKey,
                'theme': 'custom'
            });
        }
    },
    captchaReload: function captchaReload(e) {
        e.preventDefault();
        if (window.grecaptcha) {
            grecaptcha.reset();
        }
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            { id: 'recaptcha_widget', className: 'm-login--captcha' },
            _react2['default'].createElement('div', { className: 'g-recaptcha',
                'data-sitekey': this.props.recaptchaPublicKey,
                'data-theme': 'custom' })
        );
    }
});

module.exports = LogInCaptcha;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-captcha.jsx
 ** module id = 881
 ** module chunks = 0
 **/